import React, { useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getUserInformation, updateUserInformation } from '../../../../redux/profile/userInformationActions'
import { userInformationSelector } from '../../../../redux/profile/userInformationSelector'
import UserInformationForm from '../UserInformationForm'
import PasswordModal from '../ChangePassword'
import { Spinner } from '../../../../components'

const UserInformation = () => {
  const { loading, user, updateLoading } = useSelector(userInformationSelector)
  const [showModal, setShowModal] = useState(false)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getUserInformation())
  }, [dispatch])

  const editUser = useCallback(_user => {
    dispatch(updateUserInformation(_user))
  }, [dispatch])

  return (

    loading ? (<Spinner />) : (
      <>
        <UserInformationForm
          load={updateLoading}
          user={user}
          onSubmit={editUser}
          handleModal={() => setShowModal(true)}
        />
        <PasswordModal
          open={showModal}
          onClose={() => setShowModal(false)}
        />
      </>
    )

  )
}

export default UserInformation
